export const requireDefaults = {
  useCommentsFetch: () => {
    throw new Error('Not implemented. Ensure you are inside the CoreContext');
  },
  useHistoryFetch: () => {
    throw new Error('Not implemented. Ensure you are inside the CoreContext');
  },
};
